require('./common')
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const tabLinks = document.querySelectorAll('[data-tab="toggle"]');
const tabs = document.querySelectorAll('[data-tab]')
tabLinks.forEach(link => {
    link.addEventListener('click', function (e) {
        e.preventDefault();
        tabLinks.forEach(el => el.classList.remove('active'));
        this.classList.add('active');
        const tabId = this.getAttribute('href').replace('#', '');
        tabs.forEach(tab => tab.classList.remove('active'));
        document.querySelector(`[data-tab="${tabId}"]`).classList.add('active');
    })
})


